import { useContext, useEffect, useState } from "react";

import { AppContext } from "../../context/AppContext";

const useBridgeFlow = () => {
  const { version } = useContext(AppContext);
  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    if (version === "New") {
      setIsReady(true);
    }
  }, [version]);

  return {
    isReady,
  };
};

export default useBridgeFlow;
